import { render } from "./BackButtonWithBorder.vue?vue&type=template&id=0ee83a38&scoped=true"
import script from "./BackButtonWithBorder.vue?vue&type=script&lang=js"
export * from "./BackButtonWithBorder.vue?vue&type=script&lang=js"

import "./BackButtonWithBorder.vue?vue&type=style&index=0&id=0ee83a38&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0ee83a38"

export default script